import { Download, Star } from "lucide-react";

export default function Hero() {
	const stats = [
		{ value: "5K+", label: "Professionals" },
		{ value: "50K+", label: "Patients" },
		{ value: "4.9", label: "Rating", icon: <Star size={14} className="text-yellow-400 fill-yellow-400" /> },
	];

	return (
		<section className="bg-orange-50 w-full overflow-hidden">
			<div className="max-w-6xl mx-auto px-6 py-16 flex flex-col-reverse md:flex-row items-center gap-12">
				<div className="flex-1 flex flex-col items-start gap-6">
					<span className="bg-orange-100 text-primary text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wide">
						Egypt's #1 Multi-Vendor Health Care App
					</span>

					<h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
						Quality Healthcare,{" "}
						<span className="text-primary block">Delivered Home</span>
					</h1>

					<p className="text-gray-500 text-base leading-relaxed max-w-md">
						Connect with qualified doctors, nurses, and caregivers for
						professional medical services in the comfort of your home.
					</p>

					<button className="flex items-center gap-2 bg-primary hover:bg-orange-500 transition-colors text-white font-semibold px-6 py-3 rounded-full shadow-md">
						<Download size={18} />
						Download Now
					</button>

					<div className="flex items-center gap-8 mt-2">
						{stats.map((stat) => (
							<div key={stat.label} className="flex flex-col">
								<div className="flex items-center gap-1">
									{stat.icon && stat.icon}
									<span className="text-2xl font-bold text-gray-900">
										{stat.value}
									</span>
								</div>
								<span className="text-xs text-gray-400">{stat.label}</span>
							</div>
						))}
					</div>
				</div>

				<div className="flex-1 flex justify-center items-center relative">
					<div className="relative w-56 md:w-72">
						<div className="bg-gray-900 rounded-[2.5rem] p-2 shadow-2xl">
							<div className="bg-gray-100 rounded-[2rem] overflow-hidden h-[480px] md:h-[560px] flex flex-col">
								<div className="bg-white px-4 pt-4 pb-2 flex justify-between items-center text-[10px] text-gray-400">
									<span>9:41</span>
									<div className="w-16 h-4 bg-gray-900 rounded-full mx-auto absolute left-1/2 -translate-x-1/2 top-3" />
									<span>●●●</span>
								</div>

								<div className="bg-white flex-1 px-4 py-3 flex flex-col gap-3">

									<div className="flex items-center justify-between">
										<div>
											<p className="text-[9px] text-gray-400">Welcome back</p>
											<p className="text-xs font-bold text-gray-800">Ahmed Hassan</p>
										</div>
										<div className="w-7 h-7 rounded-full bg-primary flex items-center justify-center text-white text-[10px] font-bold">
											A
										</div>
									</div>

									<div className="bg-gray-100 rounded-xl px-3 py-2 text-[9px] text-gray-400">
										Search doctors, services...
									</div>

									<div className="grid grid-cols-2 gap-2">
										{["Doctor Visit", "Nurse Care", "Lab Tests", "Pharmacy"].map((item) => (
											<div
												key={item}
												className="bg-orange-50 border border-orange-100 rounded-xl p-2 text-center"
											>
												<div className="w-6 h-6 bg-primary rounded-lg mx-auto mb-1" />
												<p className="text-[8px] font-medium text-gray-700">{item}</p>
											</div>
										))}
									</div>

									<p className="text-[10px] font-bold text-gray-800">Nearby Doctors</p>
									{["Dr. Sara Ahmed", "Dr. Omar Khalil"].map((doc) => (
										<div
											key={doc}
											className="flex items-center gap-2 bg-gray-50 rounded-xl p-2"
										>
											<div className="w-7 h-7 rounded-full bg-primary opacity-80" />
											<div>
												<p className="text-[9px] font-semibold text-gray-800">{doc}</p>
												<p className="text-[8px] text-gray-400">General Physician</p>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>

						<div className="absolute -top-4 -right-6 bg-white shadow-xl rounded-2xl px-3 py-2 flex items-center gap-2 border border-gray-100 animate-bounce">
							<div className="bg-green-500 rounded-full p-1">
								<svg width="10" height="10" viewBox="0 0 10 10" fill="none">
									<path d="M2 5l2 2 4-4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</div>
							<div>
								<p className="text-[9px] font-semibold text-gray-800">Appointment</p>
								<p className="text-[8px] text-green-500 font-medium">Confirmed</p>
							</div>
						</div>
						
						<div className="absolute -z-10 top-8 left-1/2 -translate-x-1/2 w-64 h-64 bg-orange-100 rounded-full blur-3xl opacity-60" />
					</div>
				</div>
			</div>
		</section>
	);
}